export const ANAMNESIS_LOOKUP_RETRY_DELAY_MS = 1_000;
export const ANAMNESIS_LOOKUP_RETRIES = 5;
